import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from 'Components';
import './TestPickListParameter.css';

const TestPickListPackage = ({
  ToggleOn,
  IsDisabled,
  onParameterCheck,
  ParameterName,
  DetectionLimit,
  IsReadOnly,
  IsParameter,
}) => (
  <div className="test-pick-list-parameter">
    {!IsReadOnly && <CheckBox checked={ToggleOn} onClick={onParameterCheck} disabled={IsDisabled} isParameter={IsParameter} />}
    <div>
      <span>{ParameterName}</span>
      <span>{DetectionLimit}</span>
    </div>
  </div>
);

TestPickListPackage.propTypes = {
  onParameterCheck: PropTypes.func,
  ParameterName: PropTypes.string,
  DetectionLimit: PropTypes.string,
  ToggleOn: PropTypes.bool,
  IsDisabled: PropTypes.bool,
  IsReadOnly: PropTypes.bool,
  IsParameter: PropTypes.bool,
};

export default TestPickListPackage;



// WEBPACK FOOTER //
// ./src/components/TestPickList/TestPickListParameter/TestPickListParameter.jsx